/**
 * Utility functions for working with starter IDs
 */

export function starterIdToBuffer(starterId: string): ArrayBuffer {
  const output = new Uint8Array(12);
  for (let j = 0; j < 12; j++) {
    output[j] = Number.parseInt(starterId.substring(j * 2, j * 2 + 2), 16);
  }
  return output.buffer;
}
